export const capitalizeWords = (str: any) => {
  return str
    .split(" ")
    ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const filterOption = (input: any, option: any) =>
  option.children.toLowerCase().includes(input.toLowerCase());
